import axios from 'axios'
import {_handleError,_handleSuccess,_getUrl} from './Handler.js'

export function _getAll(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/roles/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _delete(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/roles/${id}`;
    return axios.delete(url,config).then(_handleSuccess,_handleError)
}
export function _getById(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/roles/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _create(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/roles`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}
export function _update(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/roles`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}

export function _getSystemAuthorities(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/roles/authorities`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _getAuthoritiesByRole(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/roles/${id}/authorities`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _updateRoleAuthorities(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/roles/authorities`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _updateRoleUsers(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/roles/users`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _getRoleUsers(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/users/role/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}